import { useReducer } from "react"
import { ProviderProps } from "../types";
import { AppReducer, initialState } from "./Action"
import { StateContext, DispatchContext } from "./Context";

const Store: React.FC<ProviderProps> = ({children}) => {

    const [state, dispatch] = useReducer(AppReducer, initialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    )    
}

export default Store;